<script>
  import { cssPrefix } from '../helper-classes.js'
</script>

<li class={`${cssPrefix}dropdown-divider`} />
